import React from 'react';
import { Select } from '../Select/index.js';
import { FormControlLayout } from './FormControlLayout.js';
import { extractLayoutProps } from './utils.js';
export const FormControlSelect = (props) => {
    const { layoutProps, inputProps } = extractLayoutProps(props);
    return (React.createElement(FormControlLayout, Object.assign({}, layoutProps),
        React.createElement(Select, Object.assign({}, inputProps))));
};
//# sourceMappingURL=FormControlSelect.js.map